// Formatter Functional Components

import React from 'react';

export function fmDate ( dateStr  )
{
  if (!dateStr || dateStr == "" ) return "";
  var d = new Date(dateStr);                

  var curr_date  = d.getUTCDate(); 
  var curr_month = d.getUTCMonth();
  var curr_year  = d.getUTCFullYear();

  var monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
                                                                                             
  return (curr_date + " " + monthNames[curr_month] + " " + curr_year);                       
}

export function fmDateTime ( dateStr  )
{
  if (!dateStr || dateStr == "" ) return "";
  var d = new Date(dateStr);                

  var curr_date  = d.getUTCDate(); 
  var curr_month = d.getUTCMonth();
  var curr_year  = d.getUTCFullYear();
  var curr_hour  = d.getUTCHours();
  var curr_min   = d.getUTCMinutes();
  var curr_sec   = d.getUTCSeconds();


  var monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
                                                                                             
  return (curr_date + " " + 
          monthNames[curr_month] + " " + 
          curr_year + " " +
          (curr_hour < 10 ? '0'+curr_hour : curr_hour) + ":" +
          (curr_min  < 10 ? '0'+curr_min  : curr_min ) + ":" +
          (curr_sec  < 10 ? '0'+curr_sec  : curr_sec ) 
         );
}

export function fmNum( numStr ) 
{
  if ( typeof numStr !== "number") return numStr;
  if (!numStr || numStr == ""  || numStr == null   || numStr == '0') return "0.00";
  var floatNum = parseFloat(numStr).toFixed(2).toString();           
  var floatNumWithSep = floatNum.toString().split(".");     
  floatNumWithSep[0] = floatNumWithSep[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");     
  return floatNumWithSep.join("."); 
}

export function fmArray(arr) {

  if (!arr || !(arr instanceof Array)) return "";

  return arr.map(function(line) {
    return <div>{line}</div>
  });
};

export  function fmAddress(addressLines) {

  if (!addressLines || !(addressLines instanceof Array)) return "";

  return addressLines.map(function(line) {
     return <div className="addressLine">{line}</div>
  });
};

export function fmColumns(row, selectedColumns, simpleDataGridOptions) {

  var arrayLength = selectedColumns.length;
  var retVal = [];
  for (var i = 0; i < arrayLength; i++) {

      //console.log(selectedColumns[i].internalName);
      //console.log(row[selectedColumns[i].internalName]);
      //console.log(typeof(row[selectedColumns[i].internalName]));

      if (selectedColumns[i].hasOwnProperty("type")) {
        if (selectedColumns[i].type == "num") {
          retVal.push(fmNum(row[selectedColumns[i].internalName]));
        } else if (selectedColumns[i].type == "date") {
          retVal.push(fmDate(row[selectedColumns[i].internalName]));
        } else if (selectedColumns[i].type == "arr") {
          retVal.push(fmArray(row[selectedColumns[i].internalName]));
        } else if (selectedColumns[i].type == "mouseOver") {
          retVal.push(simpleDataGridOptions[selectedColumns[i].internalName].mFields);
        } 
      } else {
        if (typeof(row[selectedColumns[i].internalName]) !== 'object') {
          retVal.push(row[selectedColumns[i].internalName]);
        } else {
          retVal.push(T("field_not_supported"));
        }

      }

      if (selectedColumns[i].hasOwnProperty("frozen")) {
        //retVal.push(simpleDataGridOptions[selectedColumns[i].internalName].frozen);
      }
  }    
  return retVal;
}

export function fmGrid(grid) {

  var marker = [];

  for(var i = 0; i < grid.header.length; i++) {
    marker.push(0);
  }

  for(var i = 0; i < grid.data.length; i++) {
    for(var j = 0; j < grid.data[i].length; j++) {
      if (grid.data[i][j]) marker[j] = 1;
    }
  }

  for (var i = marker.length - 1; i >= 0; i--) {
    if (marker[i] == 0) {
      grid.header.splice(i, 1);
      for (var j = grid.data.length - 1; j >= 0; j--) {
        grid.data[j].splice(i, 1);
      }
    }
  }

  return grid;
}

export function fmCompactNum(num) {
  if (num === 'TO' || num === 0) return num;

  var suffixes = ["", "K", "M", "B","T"];
  var compactNum = '';
  var suffixNum = Math.floor((""+num).length/3);
  var shortValue = parseFloat((suffixNum != 0 ? (num / Math.pow(1000,suffixNum)) : num).toPrecision(2));
  if (shortValue % 1 != 0) {
    shortValue = shortValue.toFixed(1);
  }
  compactNum = shortValue + suffixes[suffixNum];

  return compactNum;
}


export function fmDateRange(dateRangeStr) {
  if (!dateRangeStr || dateRangeStr == "" ) return "";

  let fmdateRangeStr = '';
  const dateRangeArr = dateRangeStr.split(':');
  fmdateRangeStr = fmDate(dateRangeArr[1]) + ' to ' + fmDate(dateRangeArr[2]);

  return fmdateRangeStr;
}

export function fmDateTimeToLocal(utcDateString) {
  const date = new Date(utcDateString);
  const day = String(date.getDate()).padStart(2, "0");
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  const offsetMinutes = date.getTimezoneOffset();
  const absOffset = Math.abs(offsetMinutes);
  const offsetHours = String(Math.floor(absOffset / 60)).padStart(2, "0");
  const offsetMins = String(absOffset % 60).padStart(2, "0");
  const offsetSign = offsetMinutes <= 0 ? "+" : "-";

  const timezone = `GMT${offsetSign}${offsetHours}:${offsetMins}`;

  return `${day}-${month}-${year} ${hours}:${minutes} ${timezone}`;
}

export function parseLocalDate(str) {
  if (!str) return 0;
  // Try to parse using moment if available
  if (window.moment) {
    // Accepts "01-jul-2025 13:40 GMT+5.30"
    const m = window.moment(str, ["DD-MMM-YYYY HH:mm [GMT]Z", "DD-MMM-YYYY HH:mm", "YYYY-MM-DD HH:mm:ss"]);
    if (m.isValid()) return m.valueOf();
  }
  // Fallback: try Date.parse
  const d = Date.parse(str.replace(/GMT([+-]\d+\.\d+)/, 'GMT$1'));
  if (!isNaN(d)) return d;
  return 0;
}

// Helper to show a styled tooltip
export function showCustomTooltip(target, html) {
  const old = document.getElementById('custom-report-tooltip');
  if (old) old.remove();
  const tooltip = document.createElement('div');
  tooltip.id = 'custom-report-tooltip';
  tooltip.innerHTML = html;
  tooltip.style.position = 'fixed';
  tooltip.style.background = 'rgba(255, 255, 255)';
  tooltip.style.color = '#0c0909ff';
  tooltip.style.padding = '8px 14px';
  tooltip.style.borderRadius = '6px';
  tooltip.style.fontSize = '13px';
  tooltip.style.zIndex = 9999;
  tooltip.style.pointerEvents = 'none';
  tooltip.style.boxShadow = '0 2px 8px rgba(0,0,0,0.18)';
  tooltip.style.maxWidth = '350px';
  tooltip.style.whiteSpace = 'pre-line';
  document.body.appendChild(tooltip);

  function onMouseMove(e) {
    let left = e.clientX + 50;
    let top = e.clientY + 12;

    const tooltipRect = tooltip.getBoundingClientRect();

    // Adjust if overflowing right
    if (left + tooltipRect.width > window.innerWidth) {
      left = e.clientX - tooltipRect.width - 12;
    }

    // Adjust if overflowing bottom
    if (top + tooltipRect.height > window.innerHeight) {
      top = e.clientY - tooltipRect.height - 12;
    }

    tooltip.style.left = `${left}px`;
    tooltip.style.top = `${top}px`;
  }

  function onMouseLeave() {
    tooltip.remove();
    target.removeEventListener('mousemove', onMouseMove);
    target.removeEventListener('mouseleave', onMouseLeave);
  }

  target.addEventListener('mousemove', onMouseMove);
  target.addEventListener('mouseleave', onMouseLeave);
}

// Helper to escape HTML for tooltip
export function escapeHtml(str) {
  return String(str).replace(/[&<>"']/g, function (s) {
    return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;','\'':'&#39;'})[s];
  });
}

export function enableGridAutoScrollWithMoveManager(grid, moveRowsPlugin, opts = {}) {
  const EDGE = opts.edge || 40;
  const MAX_SPEED = opts.maxSpeed || 18;
  const viewport = grid.getContainerNode().querySelector('.slick-viewport');
  if (!viewport) return;

  let isDragging = false;
  let rafId = null;
  let currentSpeed = 0;

  const stop = () => {
    isDragging = false;
    currentSpeed = 0;
    if (rafId) cancelAnimationFrame(rafId);
    rafId = null;
  };

  const step = () => {
    if (!isDragging || currentSpeed === 0) {
      rafId = null;
      return;
    }
    const maxScroll = viewport.scrollHeight - viewport.clientHeight;
    const next = Math.max(0, Math.min(maxScroll, viewport.scrollTop + currentSpeed));
    viewport.scrollTop = next;
    rafId = requestAnimationFrame(step);
  };

  const updateSpeed = (clientY) => {
    const rect = viewport.getBoundingClientRect();
    let speed = 0;

    if (clientY < rect.top + EDGE) {
      const dist = (rect.top + EDGE) - clientY;
      speed = -Math.min(MAX_SPEED, Math.ceil((dist / EDGE) * MAX_SPEED));
    } else if (clientY > rect.bottom - EDGE) {
      const dist = clientY - (rect.bottom - EDGE);
      speed = Math.min(MAX_SPEED, Math.ceil((dist / EDGE) * MAX_SPEED));
    }

    if (speed !== currentSpeed) {
      currentSpeed = speed;
      if (isDragging && !rafId && currentSpeed !== 0) {
        rafId = requestAnimationFrame(step);
      }
    }
  };

  // --- Hook RowMoveManager events ---
  moveRowsPlugin.onBeforeMoveRows.subscribe(() => {
    isDragging = true;
  });

  // As the mouse moves, RowMoveManager triggers this
  grid.onDrag.subscribe((e) => {
    if (!isDragging) return;
    updateSpeed(e.clientY);
  });

  moveRowsPlugin.onMoveRows.subscribe(() => {
    stop();
  });

  grid.onDragEnd && grid.onDragEnd.subscribe(stop);
}
export function formatResultSize(size) {
  if (size && !isNaN(size)) {
    if (size > 1024 * 1024) {
      return `${(size / (1024 * 1024)).toFixed(1)} MB`;
    } else {
      return "< 1MB";
    }
  }
  return "";
}

// Helper function to convert ISO date to MM/DD/YYYY
export function formatDateToMMDDYYYY(isoDate) {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
};

export const formatDateToYYYYMMDD = (isoDate) => {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
